<template>
  <div class="font-display relative flex items-center justify-center overflow-hidden font-medium text-white">
    <img class="h-full w-full object-cover" :src="props.image" role="presentation" />
    <router-link :to="props.link" class="absolute inset-0 flex items-center justify-center hover:scale-105">
      <div class="p-4" :class="[props.color === 'orange' ? 'bg-ul-orange-300/50' : 'bg-ul-gray-400/50']">
        <div class="text-center">{{ props.text }}</div>
      </div>
    </router-link>
  </div>
</template>

<script setup lang="ts">
type Props = {
  image: string
  text: string
  link: string
  color?: 'orange' | 'gray'
}

const props = withDefaults(defineProps<Props>(), {
  color: 'orange',
})
</script>

<style lang="scss"></style>
